export default __webpack_public_path__ + "static/media/270.0faaed74.gif";